import React, { useState, useEffect } from 'react';
import Title from '../../components/title/Title';
import SubTitle from '../../components/subTitle/SubTitle';
import { Row, Col } from 'react-bootstrap';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { faAward } from '@fortawesome/free-solid-svg-icons'
import { BE_URL, httpGet } from '../../http';
import './Certificados.css';

const Certificado = (props) => {
    return(
        <div style={{ marginBottom: '20px' }}>
            <div className='certificado-container'>
                <div className='certificado-icon-container'>
                    <FontAwesomeIcon className='view-icon' icon={faMapMarkedAlt} />
                </div>
                <div>
                    <div className='certificado-title'>{ props.children }</div>
                </div>
            </div>
        </div>
    );
}

const CertificadoCiudades = (props) => {

    const [ estado, setEstado ] = useState({
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        proveedor: {
            nit: '',
            razonSocial: '',
            tel: '',
            email: ''
        },
        loading: true,
        error: {}
    });

    const [ ciudades, setCiudades ] = useState([
        {
            "id": 4,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Cali",
            "cuenta": "236801",
            "ciudad": false,
            "ciudadRetencion": "CALI"
        },
        {
            "id": 5,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Palmira",
            "cuenta": "236802",
            "ciudad": false,
            "ciudadRetencion": "PALMIRA"
        },
        {
            "id": 6,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Cartago",
            "cuenta": "236803",
            "ciudad": false,
            "ciudadRetencion": "CARTAGO"
        },
        {
            "id": 7,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Buga",
            "cuenta": "236804",
            "ciudad": false,
            "ciudadRetencion": "BUGA"
        },
        {
            "id": 8,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Tulua",
            "cuenta": "236805",
            "ciudad": false,
            "ciudadRetencion": "TULUA"
        },
        {
            "id": 9,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Candelaria",
            "cuenta": "236806",
            "ciudad": false,
            "ciudadRetencion": "CANDELARIA"
        },
        {
            "id": 10,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Roldanillo",
            "cuenta": "236807",
            "ciudad": false,
            "ciudadRetencion": "ROLDANILLO"
        },
        {
            "id": 11,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Zarzal",
            "cuenta": "236808",
            "ciudad": false,
            "ciudadRetencion": "ZARZAL"
        },
        {
            "id": 17,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Yumbo",
            "cuenta": "236809",
            "ciudad": false,
            "ciudadRetencion": "YUMBO"
        },
        {
            "id": 18,
            "tipo": 3,
            "nivel": 2,
            "descripcion": "Retención I.C.A. Jamundí",
            "cuenta": "236811",
            "ciudad": false,
            "ciudadRetencion": "JAMUNDI"
        }
    ]);


    useEffect(() => {

        console.log(JSON.parse(sessionStorage.getItem('estado')));

        let newEstado = JSON.parse(sessionStorage.getItem('estado'));
        newEstado.proveedor = JSON.parse(sessionStorage.getItem('proveedor'));
        console.log(newEstado);
        
        setEstado(newEstado);
        //getCiudades();

    }, []);

    const getCiudades = async () => {
        const tipo = props.history.location.state.tipo.tipo;
        const resp = await httpGet(BE_URL + '/ProveedoresWS/api/Retencion/tipo-retenciones/nivel2?tipo=' + tipo);
        if(resp){
            console.log(resp.data);
            setCiudades(resp.data);
        }
    }

    return(
        <div className='page-container'>
            <Title>Certificados</Title>
            <div className='page-body'>
                <SubTitle>Empresa: { estado.empresa.razonSocial } </SubTitle>
                <SubTitle>Proveedor:</SubTitle>
                <div>
                    <div><span className='info-title'>N.I.T: </span><span>{ estado.proveedor.nit }</span></div>
                    <div><span className='info-title'>Razón social: </span><span>{ estado.proveedor.razonSocial }</span></div>
                </div>
                <br />
                <br />
                <SubTitle>Seleccione la ciudad del certificado</SubTitle>
                <div>
                    <Row className='justify-content-md-center co-row'>
                        {
                            ciudades.map(
                                (tipo, index) => {
                                    return(
                                        <Col key={index} className='co-col' xs={12} md={6} lg={6} xl={4} >
                                                <Link to={{ pathname: '/portal/retencion', state: { tipo: tipo } }}><Certificado>{tipo.descripcion}</Certificado></Link>
                                        </Col>
                                    );
                                }
                            )
                        }                        
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default CertificadoCiudades;